"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabController = void 0;
const keyKodes_1 = require("../../utils/keyKodes");
const useTabController = (tabCount) => {
    const tabRefs = Array(tabCount).fill(null);
    const setTabRefs = (index, ref) => {
        tabRefs[index] = ref;
    };
    const directions = {
        next: 1,
        prev: -1,
    };
    function handleKeyDown(e) {
        const keyCode = e.keyCode;
        switch (keyCode) {
            case keyKodes_1.keyCodes.right:
                nextFocus(directions.next);
                e.preventDefault();
                break;
            case keyKodes_1.keyCodes.left:
                nextFocus(directions.prev);
                e.preventDefault();
                break;
        }
    }
    function nextFocus(direction) {
        const activeElement = document.activeElement;
        const index = tabRefs.findIndex((tab) => tab.current === activeElement);
        if (index >= 0) {
            setFocus(nextIndex(index, direction));
        }
    }
    function setFocus(index) {
        const link = tabRefs[index].current;
        if (link) {
            link.focus();
        }
    }
    function nextIndex(index, direction) {
        return calculateNextIndex(index + direction, tabCount);
    }
    function calculateNextIndex(x, n) {
        return (x % n + n) % n;
    }
    return { handleKeyDown, setTabRefs };
};
exports.useTabController = useTabController;
//# sourceMappingURL=tabUtils.js.map